import { render } from "./Editar.vue?vue&type=template&id=f9879f8a&scoped=true"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"

import "./Editar.vue?vue&type=style&index=0&id=f9879f8a&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9879f8a"]])

export default __exports__